import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import DriverGate from '../driver/DriverGate'
import { container, h1, muted, page } from '../driver/ui'
import WalkList from './WalkList'
import WalkScreen from './WalkScreen'

/**
 * /delivery/walk/* - the property walk (walk_views.py).
 *
 * Imported EAGERLY by App.tsx, like the driver view, and behind the same offline
 * start (DriverGate): a manager opening a walk on a property with no signal gets
 * the saved walk, never the login page. Managers only - the survey is never put
 * on a driver (Brad, 2026-09-14). The server enforces that on every call; this
 * screen only says so.
 */
export default function WalkRoot() {
  return (
    <DriverGate next="/delivery/walk">
      {(ctx) =>
        ctx.session.canManage ? (
          <Routes>
            <Route index element={<WalkList offline={ctx.offline} />} />
            <Route path=":id" element={<WalkScreen offline={ctx.offline} />} />
            <Route path="*" element={<Navigate to="/delivery/walk" replace />} />
          </Routes>
        ) : (
          <div style={page}>
            <div style={container}>
              <div style={h1}>Managers only</div>
              <div style={muted}>
                The property walk is done by a delivery manager, with the customer. Ask for the manager
                delivery role if you need it.
              </div>
            </div>
          </div>
        )
      }
    </DriverGate>
  )
}
